export const VERIFY_HALL_TICKET_STATUS = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  DECLINED: 'DECLINED',
  INCOMPLETE: 'INCOMPLETE',
};
